import React from 'react';
import { BoardMember } from '@app/api/models/BoardMembers';
import styled from '@emotion/styled';
import { StyleColumn } from '../../../types/ColumnType';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import sv from 'dayjs/locale/sv';
import { L } from '../../../lib/i18n';
import { colors } from '../../../components/Shared/Style/colors';
import { margin } from '../../../components/Shared/Style/margin';
dayjs.locale(sv);

const Span = styled.span({
    textAlign: 'left',
    fontSize: '14px',
});

const StyledP = styled.p({
    color: colors.black80,
    marginTop: margin.s,
    fontSize: '12px',
});

const Properties = styled.div({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    textAlign: 'left',
    gap: '0.5rem',
    'span:no-child):after': {
        content: `","`,
    },
});

const StyledNavLink = styled(Link)({
    textDecoration: 'none',
    color: 'inherit',
});

export const COLUMNS: StyleColumn<BoardMember>[] = [
    {
        Header: () => {
            return (
                    <Span>{L('member')}</Span>
            );
        },
        id: 'member',
        accessor: (value) => [value.email, value.name],
        width: 150,
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const member = row.original;
            return (
                <StyledNavLink to={`/boardmembers/${member.id}`}>
                    <Span>{member.name}</Span>
                    <StyledP>{member.email}</StyledP>
                </StyledNavLink>
            );
        },
    },
    {
        Header: () => {
            return (
                    <Span>{L('board_member_function')}</Span>
            );
        },
        id: 'board_member_function',
        accessor: (value) => L(value.role),
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const member = row.original;
            return (
                <StyledNavLink to={`/boardmembers/${member.id}`}>
                    <Span>{L(member.role)}</Span>
                </StyledNavLink>
            );
        },
    },
    {
        Header: () => {
            return (
                    <Span>{L('board_member_responsibility')}</Span>
            );
        },
        id: 'board_member_responsibility',
        accessor: (value) => L(value.sub_role),
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const member = row.original;
            return (
                <StyledNavLink to={`/boardmembers/${member.id}`}>
                    <Span>{L(member.sub_role)}</Span>
                </StyledNavLink>
            );
        },
    },
];

export const COLUMNSMOBILE: StyleColumn<BoardMember>[] = [
    {
        Header: () => {
            return (
                    <Span>{L('member')}</Span>
            );
        },
        id: 'member',
        accessor: (value) => [value.email, value.name],
        width: 150,
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const member = row.original;
            return (
                <StyledNavLink to={`/boardmembers/${member.id}`}>
                    <Span>{member.name}</Span>
                    <StyledP>{member.email}</StyledP>
                </StyledNavLink>
            );
        },
    },
    {
        Header: () => {
            return (
                    <Span>{L('board_member_function')}</Span>
            );
        },
        id: 'board_member_function',
        accessor: (value) => L(value.role),
        style: {
            justifyContent: 'left',
            alignItems: 'center',
        },
        Cell: ({ row }) => {
            const member = row.original;
            return (
                <StyledNavLink to={`/boardmembers/${member.id}`}>
                    <Span>{L(member.role)}</Span>
                </StyledNavLink>
            );
        },
    },
];
